/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addDependencies } from './dependenciesAdd.generated.js';
import { applyDependencies } from './dependenciesApply.generated.js';
import { divideDependencies } from './dependenciesDivide.generated.js';
import { isNaNDependencies } from './dependenciesIsNaN.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { subtractDependencies } from './dependenciesSubtract.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createVariance } from '../../factoriesAny.js';
export var varianceDependencies = {
  addDependencies,
  applyDependencies,
  divideDependencies,
  isNaNDependencies,
  multiplyDependencies,
  subtractDependencies,
  typedDependencies,
  createVariance
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesVariance.generated.js
// module id = 378
// module chunks = 2